export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 100 CARDS',
    cards: [
      {n:'1', name:'What Remains', artist:'Candice Dailey'},
      {n:'2', name:'Luke Skywalker', artist:'Dave Seely'},
      {n:'3', name:'The Duel', artist:'Ignacio RC'},
      {n:'4', name:'Narrow Escape', artist:'Claudio Aboy'},
      {n:'5', name:'The Empire', artist:'Davide Fabbri'},
      {n:'6', name:'Gimmie', artist:'Tricia Buchanan-Benson'},
      {n:'7', name:"It's Not a Matter Of Luck", artist:'Brent Woodside'},
      {n:'8', name:'New Visions', artist:'Steven Chorney'},
      {n:'9', name:'Obi-Wan Kenobi', artist:'Steve Chorney'},
      {n:'10', name:'Protocol Droid', artist:'Archives'},
      {n:'11', name:'Protecting Hope', artist:'Claudio Aboy'},
      {n:'12', name:'General Grievous', artist:'Terese Nielsen'},
      {n:'13', name:'Loyalty Means Everything', artist:'Kayla Woodside'},
      {n:'14', name:'Awakening of A Jedi', artist:'Ignacio RC'},
      {n:'15', name:'Qui-Gon Jinn', artist:'Archives'},
      {n:'16', name:'Goin-In', artist:'Archives'},
      {n:'17', name:'Wedge Antilles', artist:'Dave Dorman'},
      {n:'18', name:'Joyride', artist:'Cliff Cramp'},
      {n:'19', name:'Royalty', artist:'Brent Woodside'},
      {n:'20', name:'Wizard', artist:'Jenna McMullins'},
      {n:'21', name:'The Confrontation', artist:'Karl Fitzgerald'},
      {n:'22', name:'You Were My Brother', artist:'Meghan Gabriels'},
      {n:'23', name:'Bounty Hunters', artist:'Dave Dorman'},
      {n:'24', name:'Confrontation', artist:'Jaime Carillo'},
      {n:'25', name:'Obsession #1', artist:'Brian Chung'},
      {n:'26', name:'The Resistance', artist:'Archives'},
      {n:'27', name:'The First Order', artist:'Archives'},
      {n:'28', name:'The Ewoks Join the Fight', artist:'Bonnie Bogart'},
      {n:'29', name:'Tatooine Cruise', artist:'Mark Chilcott'},
      {n:'30', name:'Learning the Force', artist:'Akirant'},
      {n:'31', name:'Mace Windu', artist:'Archives'},
      {n:'32', name:'Dooku', artist:'Archives'},
      {n:'33', name:'The Grand Admiral', artist:'Brandon Kenney'},
      {n:'34', name:'The Wampa', artist:'Hugh Fleming'},
      {n:'35', name:'Admiral Piett', artist:'Christopher Moeller'},
      {n:'36', name:'Podracing', artist:'Hugh Fleming'},
      {n:"37", name:"Smuggler's Moon", artist:'Dave Dorman'},
      {n:'38', name:'The Wanderer', artist:'Brandon Kenney'},
      {n:'39', name:'The Mandalorian', artist:'Yusuke Osawa'},
      {n:'40', name:'Across the Stars', artist:'Kayla Woodside'},
      {n:'41', name:'Masterhood', artist:'Joe Hogan'},
      {n:'42', name:"I've Got This", artist:'Brian Rood'},
      {n:'43', name:'Plo Koon', artist:'Jerry Vanderstelt'},
      {n:'44', name:'Kit Fisto', artist:'Terese Nielsen'},
      {n:'45', name:'The Rancor', artist:'RJ Palmer'},
      {n:'46', name:'Eta-2 Actis class interceptor', artist:'Tommy Lee Edwards'},
      {n:'47', name:"I Don't Think They're Going To Let Us In", artist:'Dave Dorman'},
      {n:'48', name:'Carbonite Chamber', artist:'Kevin Wilson'},
      {n:'49', name:'Wicket and R2-D2', artist:'Hugh Fleming'},
      {n:'50', name:'Our Most Desperate Hour', artist:'Natalia Sanabria'},
      {n:'51', name:'Luke Skywalker and Obi-Wan Kenobi', artist:'John Alvin'},
      {n:'52', name:'Power in Numbers', artist:'Raymond Swanland'},
      {n:'53', name:'Shattered', artist:'Jenna McMullins'},
      {n:'54', name:'Rule With Respect', artist:'Adam Schickling'},
      {n:'55', name:'Making a Jedi', artist:'Ignacio RC'},
      {n:'56', name:'Rescue Mission', artist:'Guy Vasilovich'},
      {n:'57', name:'Darth Vader and the Speeders', artist:'Christopher Moeller'},
      {n:'58', name:'Alone I Stand', artist:'Christophe Vacher'},
      {n:'59', name:'The Clones', artist:'Chris Valentine'},
      {n:'60', name:'I Will Teach You to Protect Yourself', artist:'Jeremy Saliba'},
      {n:'61', name:'Dark Entrance', artist:'Jeremy Saliba'},
      {n:'62', name:"I've Got Your Back", artist:'Tricia Buchanan-Benson'},
      {n:'63', name:'The Kyber Crystal', artist:'Chris Trevas'},
      {n:'64', name:'Hoth Mission', artist:'Mark Chilcott'},
      {n:'65', name:'Friendly Ambush', artist:'Guy Vasilovich'},
      {n:'66', name:"Road to Jabba's Palace", artist:'Guy Vasilovich'},
      {n:'67', name:'Chirrut Îmwe', artist:'Gabz'},
      {n:'68', name:'Fall of the Jedi', artist:'Dave Dorman'},
      {n:'69', name:'Jyn Erso', artist:'Gabz'},
      {n:'70', name:"The Emperor's Wrath", artist:'Tommy Lee Edwards'},
      {n:'71', name:'Anakin and Ahsoka', artist:'Terese Nielsen'},
      {n:'72', name:'Hoth Battle', artist:'Claudio Aboy'},
      {n:'73', name:'Docking Bay', artist:'Pablo Olivera'},
      {n:'74', name:'Marshal of Mos Pelgo', artist:'Mark Englert'},
      {n:'75', name:'Usurper', artist:'Candice Dailey'},
      {n:'76', name:'Dagobah', artist:'PhaseRunner'},
      {n:'77', name:'Tatooine', artist:'PhaseRunner'},
      {n:'78', name:'Mustafar', artist:'PhaseRunner'},
      {n:'79', name:'N-1 Starfighters', artist:'Archives'},
      {n:'80', name:'Avenge my Master', artist:'Claudio Aboy'},
      {n:'81', name:"Skywalker's Starfighter", artist:'Tommy Lee Edwards'},
      {n:'82', name:'Separated at Birth', artist:'Hugh Fleming'},
      {n:'83', name:'Trench Run', artist:'Rob Kaz'},
      {n:'84', name:'The Life of Luke Skywalker', artist:'Ryder Windham'},
      {n:'85', name:'Until Our Last Breath', artist:'Christophe Vacher'},
      {n:'86', name:'The Gunslinger', artist:'Brian Rood'},
      {n:'87', name:'Surprise Clankers!', artist:'Brent Woodside'},
      {n:'88', name:'Anakin Skywalker', artist:'Tommy Lee Edwards'},
      {n:'89', name:'Captain of the 501st', artist:'Terese Nielsen'},
      {n:'90', name:'Uninvited Guests', artist:'Jack Gregory'},
      {n:'91', name:'One Last Lesson', artist:'Brent Woodside'},
      {n:'92', name:'Lord Vader', artist:'Kevin Wilson'},
      {n:'93', name:'Checkpoint', artist:'Akirant'},
      {n:'94', name:'Han and Chewie', artist:'Chris Trevas'},
      {n:'95', name:'Shadow of Evil', artist:'Tsuneo Sanda'},
      {n:'96', name:'Boarding Party', artist:'Jack Gregory'},
      {n:'97', name:'The Falcon on Crait', artist:'Derek Payne'},
      {n:'98', name:'At Last We Will Have Revenge', artist:'Devin Schoeffler'},
      {n:'99', name:'B-wing Starfighters', artist:'Tommy Lee Edwards'},
      {n:'100', name:'Throughout the Ages', artist:'Kayla Woodside'},
    ]
  },
  {
    id: 'galactic-inspirations', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'GALACTIC INSPIRATIONS — 15 CARDS',
    cards: [
      {n:'SWIN-1', name:'X-Wing And The Death Star', artist:'Joe Corroney'},
      {n:'SWIN-2', name:"Luke In The Wampa's Den", artist:'Joe Corroney'},
      {n:'SWIN-3', name:'Luke Vs The Scout Trooper', artist:'Joe Corroney'},
      {n:'SWIN-4', name:'Darth Vader Observes', artist:'Joe Corroney'},
      {n:'SWIN-5', name:'Battle Droid Down', artist:'Joe Corroney'},
      {n:'SWIN-6', name:'Jar Jar Binks', artist:'Joe Corroney'},
      {n:'SWIN-7', name:'The Queen Of Naboo', artist:'Joe Corroney'},
      {n:'SWIN-8', name:'Obi-Wan Strikes Down Darth Maul', artist:'Joe Corroney'},
      {n:'SWIN-9', name:'The Medal Ceremony', artist:'Joe Corroney'},
      {n:'SWIN-10', name:'Into The Nebula', artist:'Joe Corroney'},
      {n:'SWIN-11', name:"Luke's Recovery", artist:'Joe Corroney'},
      {n:'SWIN-12', name:'Training With Yoda', artist:'Joe Corroney'},
      {n:'SWIN-13', name:'AT-AT', artist:'Joe Corroney'},
      {n:'SWIN-14', name:'Attack On The Death Star', artist:'Joe Corroney'},
      {n:'SWIN-15', name:'Worrt On Tatooine', artist:'Joe Corroney'},
    ]
  },
  {
    id: 'duel-mustafar', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'DUEL ON MUSTAFAR — 15 CARDS',
    cards: [
      {n:'DOM-1', name:'The Duel Begins', artist:'Christian Benavides'},
      {n:'DOM-2', name:'Mustafar Control Room', artist:'Christian Benavides'},
      {n:'DOM-3', name:"Anakin's Chokehold", artist:'Christian Benavides'},
      {n:'DOM-4', name:'A Near-Fatal Strike', artist:'Christian Benavides'},
      {n:'DOM-5', name:'Equals In The Force', artist:'Christian Benavides'},
      {n:'DOM-6', name:'Taking The Duel Outside', artist:'Christian Benavides'},
      {n:'DOM-7', name:'A Narrow Battleground', artist:'Christian Benavides'},
      {n:'DOM-8', name:'A Heated Confrontation', artist:'Christian Benavides'},
      {n:'DOM-9', name:'Mustafar Rain', artist:'Christian Benavides'},
      {n:'DOM-10', name:'A Swinging Joust', artist:'Christian Benavides'},
      {n:'DOM-11', name:'Anakin Skywalker Closes In', artist:'Christian Benavides'},
      {n:'DOM-12', name:'Battle On The Lava River', artist:'Christian Benavides'},
      {n:'DOM-13', name:'"I Have The High Ground"', artist:'Christian Benavides'},
      {n:'DOM-14', name:'"You Underestimate My Power"', artist:'Christian Benavides'},
      {n:'DOM-15', name:'A Fiery Conclusion', artist:'Christian Benavides'},
    ]
  },
  {
    id: 'power-force', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'POWER OF THE FORCE — 15 CARDS',
    cards: [
      {n:'POW-1', name:'Captain Phasma', artist:'Joel Chaim Holtzman'},
      {n:'POW-2', name:'Finn', artist:'Joel Chaim Holtzman'},
      {n:'POW-3', name:'Unkar Plutt', artist:'Joel Chaim Holtzman'},
      {n:'POW-4', name:'BB-8', artist:'Joel Chaim Holtzman'},
      {n:'POW-5', name:'C-3PO', artist:'Joel Chaim Holtzman'},
      {n:'POW-6', name:'R2-D2', artist:'Joel Chaim Holtzman'},
      {n:'POW-7', name:'Chewbacca', artist:'Joel Chaim Holtzman'},
      {n:'POW-8', name:'Han Solo', artist:'Joel Chaim Holtzman'},
      {n:'POW-9', name:'Poe Dameron', artist:'Joel Chaim Holtzman'},
      {n:'POW-10', name:'Kylo Ren', artist:'Joel Chaim Holtzman'},
      {n:'POW-11', name:'General Hux', artist:'Joel Chaim Holtzman'},
      {n:'POW-12', name:'Leia Organa', artist:'Joel Chaim Holtzman'},
      {n:'POW-13', name:'Stormtrooper', artist:'Joel Chaim Holtzman'},
      {n:'POW-14', name:'Rey', artist:'Joel Chaim Holtzman'},
      {n:'POW-15', name:'Luke Skywalker', artist:'Joel Chaim Holtzman'},
    ]
  },
  {
    id: 'fear-darkside', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'FEAR THE DARKSIDE — 15 CARDS',
    cards: [
      {n:'FTD-1', name:'Kylo Ren', artist:'Danny Schlitz'},
      {n:'FTD-2', name:'Darth Vader', artist:'Danny Schlitz'},
      {n:'FTD-3', name:'The Stranger', artist:'Danny Schlitz'},
      {n:'FTD-4', name:'Baylan Skoll', artist:'Danny Schlitz'},
      {n:'FTD-5', name:'Shin Hati', artist:'Danny Schlitz'},
      {n:'FTD-6', name:'General Grievous', artist:'Danny Schlitz'},
      {n:'FTD-7', name:'Supreme Leader Snoke', artist:'Danny Schlitz'},
      {n:'FTD-8', name:'Darth Plagueis', artist:'Danny Schlitz'},
      {n:'FTD-9', name:'Count Dooku', artist:'Danny Schlitz'},
      {n:'FTD-10', name:'Darth Maul', artist:'Danny Schlitz'},
      {n:'FTD-11', name:'Darth Bane', artist:'Danny Schlitz'},
      {n:'FTD-12', name:'Asajj Ventress', artist:'Danny Schlitz'},
      {n:'FTD-13', name:'Emperor Palpatine', artist:'Danny Schlitz'},
      {n:'FTD-14', name:'The Seventh Sister', artist:'Danny Schlitz'},
      {n:'FTD-15', name:'The Grand Inquisitor', artist:'Danny Schlitz'},
    ]
  },
  {
    id: 'chrome-layers', parallels: [{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'TOPPS CHROME LAYERS — RALPH MCQUARRIE — 15 CARDS',
    cards: [
      {n:'LAY-1', name:'Desert Skiff', artist:'Ralph McQuarrie'},
      {n:'LAY-2', name:'Hoth Base', artist:'Ralph McQuarrie'},
      {n:'LAY-3', name:"Jabba's Palace", artist:'Ralph McQuarrie'},
      {n:'LAY-4', name:'Darth Vader Duel', artist:'Ralph McQuarrie'},
      {n:'LAY-5', name:'Trench Run', artist:'Ralph McQuarrie'},
      {n:'LAY-6', name:'Crashed Snowspeeder', artist:'Ralph McQuarrie'},
      {n:'LAY-7', name:'Darth Vader vs Luke Skywalker', artist:'Ralph McQuarrie'},
      {n:"LAY-8", name:"Jabba's Droids", artist:'Ralph McQuarrie'},
      {n:'LAY-9', name:'The Death Star', artist:'Ralph McQuarrie'},
      {n:'LAY-10', name:'Cloud City', artist:'Ralph McQuarrie'},
      {n:'LAY-11', name:'Lando Calrissian greets Han Solo', artist:'Ralph McQuarrie'},
      {n:'LAY-12', name:'Snowspeeder vs AT-AT', artist:'Ralph McQuarrie'},
      {n:'LAY-13', name:'Chasing the Falcon', artist:'Ralph McQuarrie'},
      {n:'LAY-14', name:'AT-ATs Attack!', artist:'Ralph McQuarrie'},
      {n:'LAY-15', name:"Mon Mothma's Intel", artist:'Ralph McQuarrie'},
    ]
  },
  {
    id: 'comicfractor', parallels: [{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'COMICFRACTOR — 5 CARDS',
    cards: [
      {n:'VC-11', name:'Qui-Gon Jinn', artist:''},
      {n:'VC-12', name:'Darth Maul', artist:''},
      {n:'VC-13', name:'Stormtrooper', artist:''},
      {n:'VC-14', name:'Leia Organa', artist:''},
      {n:'VC-15', name:'AT-AT Driver', artist:''},
    ]
  },
  {
    id: 'one-force', parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'ONE WITH THE FORCE — 5 CARDS (1/1 SUPERFRACTORS)',
    cards: [
      {n:'OF-11', name:'Ki-Adi-Mundi', artist:''},
      {n:'OF-12', name:'Jedi Master Sol', artist:''},
      {n:'OF-13', name:'Jedi Master Indara', artist:''},
      {n:'OF-14', name:'Supreme Leader Snoke', artist:''},
      {n:'OF-15', name:'Emperor Palpatine', artist:''},
    ]
  },
  {
    id: 'puzzle-ahsoka', parallels: [{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'ORIGINAL ART PUZZLE — AHSOKA — 9 CARDS',
    cards: [
      {n:'AP-1', name:'Ahsoka Tano', artist:'Aurelio Lorenzo'},
      {n:'AP-2', name:'Sabine Wren', artist:'Aurelio Lorenzo'},
      {n:'AP-3', name:'Ezra Bridger', artist:'Aurelio Lorenzo'},
      {n:'AP-4', name:'Baylan Skoll', artist:'Aurelio Lorenzo'},
      {n:'AP-5', name:'Shin Hati', artist:'Aurelio Lorenzo'},
      {n:'AP-6', name:'Hera Syndulla', artist:'Aurelio Lorenzo'},
      {n:'AP-7', name:'Grand Admiral Thrawn', artist:'Aurelio Lorenzo'},
      {n:'AP-8', name:'Captain Enoch', artist:'Aurelio Lorenzo'},
      {n:'AP-9', name:'Chopper', artist:'Aurelio Lorenzo'},
    ]
  },
  {
    id: 'puzzle-skeleton', parallels: [{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'ORIGINAL ART PUZZLE — SKELETON CREW — 9 CARDS',
    cards: [
      {n:'SCP-1', name:'Jod', artist:'Joe Corroney'},
      {n:'SCP-2', name:'SM-33', artist:'Joe Corroney'},
      {n:'SCP-3', name:'Neel', artist:'Joe Corroney'},
      {n:'SCP-4', name:'Wim', artist:'Joe Corroney'},
      {n:"SCP-5", name:"Khy'mm", artist:'Joe Corroney'},
      {n:'SCP-6', name:'Wendle', artist:'Joe Corroney'},
      {n:'SCP-7', name:'Fara', artist:'Joe Corroney'},
      {n:'SCP-8', name:'Fern', artist:'Joe Corroney'},
      {n:'SCP-9', name:'KB', artist:'Joe Corroney'},
    ]
  },
  {
    id: 'mcquarrie-buybacks', parallels: [{id:'green-shimmer',name:'Green Shimmer Refractor',print_run:199,color:'#00e87a'},{id:'blue-ray-wave',name:'Blue Ray Wave Refractor',print_run:175,color:'#2979ff'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'prism',name:'Prism Refractor',print_run:75,color:'#e040fb'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'xfractor',name:'X-Fractor',print_run:10,color:'#76ff03'},{id:'red-logofractor',name:'Star Wars Red Logofractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'insert', title: 'RALPH MCQUARRIE BUYBACKS — 20 CARDS',
    cards: [
      {n:'MCQ-1', name:'1993 Star Wars Galaxy Series 1 #15', artist:''},
      {n:'MCQ-2', name:'1993 Star Wars Galaxy Series 1 #42', artist:''},
      {n:'MCQ-3', name:'1993 Star Wars Galaxy Series 1 #43', artist:''},
      {n:'MCQ-4', name:'1993 Star Wars Galaxy Series 1 #44', artist:''},
      {n:'MCQ-5', name:'1993 Star Wars Galaxy Series 1 #45', artist:''},
      {n:'MCQ-6', name:'1993 Star Wars Galaxy Series 1 #46', artist:''},
      {n:'MCQ-7', name:'1993 Star Wars Galaxy Series 1 #47', artist:''},
      {n:'MCQ-8', name:'1993 Star Wars Galaxy Series 1 #57', artist:''},
      {n:'MCQ-9', name:'1993 Star Wars Galaxy Series 1 #59', artist:''},
      {n:'MCQ-10', name:'1993 Star Wars Galaxy Series 1 #60', artist:''},
      {n:'MCQ-11', name:'1993 Star Wars Galaxy Series 1 #68', artist:''},
      {n:'MCQ-12', name:'1993 Star Wars Galaxy Series 1 #75', artist:''},
      {n:'MCQ-13', name:'1993 Star Wars Galaxy Series 1 #77', artist:''},
      {n:'MCQ-14', name:'1994 Star Wars Galaxy Series 2 #142', artist:''},
      {n:'MCQ-15', name:'1994 Star Wars Galaxy Series 2 #143', artist:''},
      {n:'MCQ-16', name:'1994 Star Wars Galaxy Series 2 #144', artist:''},
      {n:'MCQ-17', name:'1994 Star Wars Galaxy Series 2 #145', artist:''},
      {n:'MCQ-18', name:'1994 Star Wars Galaxy Series 2 #146', artist:''},
      {n:'MCQ-19', name:'1994 Star Wars Galaxy Series 2 #147', artist:''},
      {n:'MCQ-20', name:'1994 Star Wars Galaxy Series 2 #148', artist:''},
    ]
  },
  {
    id: 'auto-single', parallels: [{id:'numbered',name:'',print_run:199,color:'#c8d8f0'},{id:'atomic',name:'Atomic Refractor',print_run:150,color:'#00bcd4'},{id:'wave',name:'Wave Refractor',print_run:99,color:'#00b0ff'},{id:'mojo',name:'Mojo Refractor',print_run:50,color:'#ff6d00'},{id:'orange',name:'Orange Refractor',print_run:25,color:'#ff9100'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'GALAXY AUTOGRAPHS — 49 CARDS',
    cards: [
      {n:'GA-AA', name:'Adria Arjona', artist:'Bix Caleen'},
      {n:'GA-AD', name:'Adam Driver', artist:'Kylo Ren'},
      {n:'GA-BL', name:'Billie Lourd', artist:'Lieutenant Connix'},
      {n:'GA-BW', name:'Billy Dee Williams', artist:'Lando Calrissian'},
      {n:'GA-C3', name:'Anthony Daniels', artist:'C-3PO'},
      {n:'GA-CM', name:'Carrie-Anne Moss', artist:'Jedi Master Indara'},
      {n:'GA-DG', name:'Denise Gough', artist:'Dedra Meero'},
      {n:'GA-DK', name:'Dafne Keen', artist:'Jecki Lon'},
      {n:'GA-DL', name:'Diego Luna', artist:'Cassian Andor'},
      {n:'GA-DO', name:'Domhnall Gleeson', artist:'General Hux'},
      {n:'GA-DR', name:'Daisy Ridley', artist:'Rey'},
      {n:'GA-EC', name:'Emilia Clarke', artist:"Qi'ra"},
      {n:'GA-ECK', name:'Ashley Eckstein', artist:'Ahsoka Tano'},
      {n:'GA-EM', name:'Ewan McGregor', artist:'Obi-Wan Kenobi'},
      {n:'GA-EW', name:'Elijah Wood', artist:'Jace Rucklin'},
      {n:'GA-FJ', name:'Felicity Jones', artist:'Jyn Erso'},
      {n:'GA-FW', name:'Forest Whitaker', artist:'Saw Gerrera'},
      {n:'GA-GC', name:'Gwendoline Christie', artist:'Captain Phasma'},
      {n:'GA-GO', name:"Genevieve O'Reilly", artist:'Mon Mothma'},
      {n:'GA-HC', name:'Hayden Christensen', artist:'Darth Vader'},
      {n:'GA-HF', name:'Harrison Ford', artist:'Han Solo'},
      {n:'GA-IM', name:'Ian McDiarmid', artist:'Darth Sidious'},
      {n:'GA-IS', name:'Ivanna Sakhno', artist:'Shin Hati'},
      {n:'GA-JAL', name:'Jaleel White', artist:'Gunter'},
      {n:'GA-JB', name:'Jennifer Beals', artist:'Garsa Fwip'},
      {n:'GA-JOO', name:'Joonas Suotamo', artist:'Chewbacca'},
      {n:'GA-JT', name:'Justin Theroux', artist:'Master Codebreaker'},
      {n:'GA-LAW', name:'Jude Law', artist:'Jod Na Nawood'},
      {n:'GA-LJ', name:'Lee Jung-jae', artist:'Jedi Master Sol'},
      {n:'GA-LM', name:'Lars Mikkelsen', artist:'Grand Admiral Thrawn'},
      {n:'GA-MH', name:'Mark Hamill', artist:'Luke Skywalker'},
      {n:'GA-MJ', name:'Manny Jacinto', artist:'The Stranger'},
      {n:'GA-NN', name:'Nick Nolte', artist:'Kuiil'},
      {n:'GA-NO', name:'John Leguizamo', artist:'Gor Koresh'},
      {n:'GA-NP', name:'Natalie Portman', artist:'Padmé Amidala'},
      {n:'GA-OJ', name:"O'Shea Jackson Jr.", artist:'Kawlan Roken'},
      {n:'GA-PP', name:'Pedro Pascal', artist:'The Mandalorian'},
      {n:'GA-RA', name:'Riz Ahmed', artist:'Bodhi Rook'},
      {n:'GA-RH', name:'Ron Howard', artist:'Director'},
      {n:'GA-RP', name:'Ray Park', artist:'Darth Maul'},
      {n:'GA-RS', name:'Robert Timothy Smith', artist:'Neel'},
      {n:'GA-SG', name:'Sarah Michelle Gellar', artist:'Seventh Sister'},
      {n:'GA-SJ', name:'Samuel L. Jackson', artist:'Mace Windu'},
      {n:'GA-SS', name:'Stellan Skarsgård', artist:'Luthen Rael'},
      {n:'GA-SW', name:'Sam Witwer', artist:'Maul'},
      {n:'GA-TM', name:'Temuera Morrison', artist:'Boba Fett'},
      {n:'GA-TN', name:'Thandiwe Newton', artist:'Val'},
      {n:'GA-WD', name:'Warwick Davis', artist:'Wicket W. Warrick'},
      {n:'GA-ZB', name:'Zach Braff', artist:'Freck'},
    ]
  },
  {
    // The base Dual Auto is itself serial /10, above the Red /5 — rule-6 slot so a
    // collector can record which copy they own. Confirmed by specimen (eBay DA-DR
    // Morgan Elsbeth / Ahsoka Tano, Print Run /10) plus SI, Checklist Insider and
    // TraderCracks. Triple/Quad bases are /5 and are already served by their Red /5.
    id: 'auto-dual', parallels: [{id:'numbered',name:'',print_run:10,color:'#c8d8f0'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'red-logofractor',name:'Star Wars Red Logofractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'DUAL AUTOGRAPHS — 10 CARDS',
    cards: [
      {n:'DA-AD', name:'Adam Driver / Daisy Ridley', artist:'Kylo Ren / Rey'},
      {n:'DA-DR', name:'Diana Lee Inosanto / Rosario Dawson', artist:'Morgan / Ahsoka'},
      {n:'DA-EP', name:'Paul Bettany / Emilia Clarke', artist:'Dryden / Qi\'ra'},
      {n:'DA-FA', name:"Freddie Prinze Jr. / Ashley Eckstein", artist:'Kanan / Ahsoka'},
      {n:'DA-KD', name:'Denise Gough / Kyle Soller', artist:'Dedra / Syril'},
      {n:'DA-LI', name:'Ivanna Sakhno / Lars Mikkelsen', artist:'Shin / Thrawn'},
      {n:'DA-OK', name:'Oscar Isaac / Keri Russell', artist:'Poe / Zorii'},
      {n:'DA-PM', name:'Mark Hamill / Pedro Pascal', artist:'Luke / Mando'},
      {n:'DA-RR', name:'Robert Timothy Smith / Ravi Cabot-Conyers', artist:'Neel / Wim'},
      {n:'DA-SG', name:"Genevieve O'Reilly / Stellan Skarsgård", artist:'Mon Mothma / Luthen'},
    ]
  },
  {
    // Base is /5 ("All cards are /5" — Checklist Insider + TraderCracks, both
    // listing Superfractor as the only parallel). Rule-6 slot so a collector can
    // record which copy they own; the /5 they hold is the base, not a Refractor.
    id: 'auto-triple', parallels: [{id:'numbered',name:'',print_run:5,color:'#c8d8f0'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'red-logofractor',name:'Star Wars Red Logofractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'TRIPLE AUTOGRAPHS — 5 CARDS',
    cards: [
      {n:'TA-AFS', name:'Sam Witwer / Freddie Prinze Jr. / Ashley Eckstein', artist:'Rebels Cast'},
      {n:'TA-DSG', name:'Diego Luna / Genevieve O\'Reilly / Stellan Skarsgård', artist:'Andor Cast'},
      {n:'TA-H3M', name:'Harrison Ford / Anthony Daniels / Mark Hamill', artist:'OT Cast'},
      {n:'TA-MHB', name:'Harrison Ford / Billy Dee Williams / Mark Hamill', artist:'OT Cast'},
      {n:'TA-TKG', name:'Katee Sackhoff / Giancarlo Esposito / Pedro Pascal', artist:'Mando Cast'},
    ]
  },
  {
    // Base is /5 ("All cards are /5" — Checklist Insider + TraderCracks, both
    // listing Superfractor as the only parallel). Rule-6 slot so a collector can
    // record which copy they own; the /5 they hold is the base, not a Refractor.
    id: 'auto-quad', parallels: [{id:'numbered',name:'',print_run:5,color:'#c8d8f0'},{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'red-logofractor',name:'Star Wars Red Logofractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'QUAD AUTOGRAPHS — 4 CARDS',
    cards: [
      {n:'Q-ADSG', name:"Genevieve O'Reilly / Stellan Skarsgård / Adria Arjona / Diego Luna", artist:'Andor Cast'},
      {n:'Q-JNJF', name:'Jaleel White / Fred Tatasciore / Nick Frost / Jude Law', artist:'Skeleton Crew Cast'},
      {n:'Q-RNME', name:'Natasha Liu Bordizzo / Rosario Dawson / Eman Esfandi / Mary Elizabeth Winstead', artist:'Ahsoka Cast'},
      {n:'Q-SETH', name:'Temuera Morrison / Ewan McGregor / Hayden Christensen / Samuel L. Jackson', artist:'Prequel Cast'},
    ]
  },
  {
    id: 'auto-buybacks', parallels: [], type: 'auto', title: 'AUTOGRAPH BUYBACKS — 2 CARDS',
    cards: [
      {n:'AB-15', name:'1993 Star Wars Galaxy Series 1 #15', artist:'Autograph Buyback'},
      {n:'AB-43', name:'1993 Star Wars Galaxy Series 1 #43', artist:'Autograph Buyback'},
    ]
  },
  {
    id: 'blank-canvas', parallels: [], type: 'sketch', title: 'BLANK CANVAS SKETCH CARD ARTISTS — 7',
    cards: [
      'Aaron Soon', 'Tatyana Drewry Carvin', 'Tori Niu', 'Chris Madden',
      'Taylor Chojecki', 'Scott Zenteno', 'Justin Bruce Lee',
    ].map((a, i) => ({n: `BCS-${i+1}`, name: a, artist: 'Blank Canvas Artist'}))
  },
  {
    id: 'sketch', parallels: [], type: 'sketch', title: 'SKETCH CARD ARTISTS — 108 ARTISTS',
    cards: [
      'Adam Beck','Adam Fields','Aleksandr Gigov','Alex Mines','Allen Geneta','Allen Grimes',
      'Andrew Fry','Andy Hanks','Angel Aviles','Angelina Benedetti','Anthony Pietszak',
      'Antni Ellison','Ash Gonzales','Ashley Marsh','Basak Kahraman','Bean','Ben AbuSaada',
      'Bobby Blakey','Brandon Klein','C DUB','Charlie Cody','Chenduz','Chris Colyer',
      'Chris Meeks','Cory Payne CMP','Court','Cyrus Sherkat','Dan Bergren','Dan Cooney',
      'Dan Curto','Dan Gorman','Dan Lawler','Dan Tearle','Daniel Riveron','Darrin Pepe',
      'David Willingham','Dawn Murphy','Dove McHargue','Dwayne Carpenter','DYJ','Dylan Riley',
      'El Smetchö','Elson Jr. Art','Elvin A Hernandez','Emma Douglas','Emrah Cildir',
      'Emre Varlibas','Enrica Martine Pitrolino','Eric Lehtonen','Erik Muller',
      'Evgheni REBL Batu','Frank A. Kadar','Frank Sansone','Franklim Teixeira',
      'Guilherme Rocha','Ian McKesson','Jaime Lopez','James Boyd','James Harris',
      'Jamie Richards','Jane Rushton','Jason Christner','Jason Pearce','Jason Queen',
      'Jason Sobol','Jay Manchand','Jeffrey C. Benitez','Jenny Kim','Jessica Hickman',
      'Jessica Van Dusen','Jiaxin YinShan Sun','Jim O\'Riley','Joe Ortiz',
      'John JAR Rodriguez','John Boren','John Bruce','John Still','Jojo Hilario',
      'Josh Trout','Julia McKenzie','Julie-Anne','Kang Jing','Karl Jones','Kevin Cleveland',
      'Kevin P. West','Kevin Scott Jacobs','Khloe Delnick','Khushi Mahajan','Kris Penix',
      'Krishna Sharma','Laura Inglis','Lee Lightfoot','Limuel Pinzon','Lindsey Greyling',
      'Luke Rushton LR','Marcia Dye','Marlo Agunos','Marlo Martos','Matthew Maldonado',
      'Matthew Sutton','Michael Mastermaker','Mike Dalzell','Mike LaPeruta',
      'Mohammad Jilani','Neil A Brady','Neil Camera','Nick Gribbon','Nick Sutphin',
      'Niño John Benitez','Oscar Chavez','Patricio Carrasco','Patrick Giles',
      'Phillip Trujillo','Randy Siplon','Rees Chua-Finlay','Rich RAM Molinelli',
      'Rich Hennemann','Rico Dela Rosa','Robert Hendrickson','Roy Cover','Rugved Bhuskute',
      'Rustico Limosinero','Rutvig Vaid','Ryan Edwards','Ryan Finley','Ryan Johnston',
      'Ryan Thompson','Scott Anthony','Scott Houseman','Scott West','Scribbling Joe',
      'Sean Mathews','Semra Bulut','Shaow Siong','Shyla Lee','Sir Edmund Duke',
      'Stephane Leonardi','Stephanie Swanger','Steve Alce','Stirling Ford','Ted Dastick Jr',
      'Tim Shinn','Tom Amici','TOMA','Tomoko Taniguchi','Traci Easterday','Trent Westbrook',
      'Veronica Louro','Vini Pirani','Ward Silverman','Will Pleydon','Zach Woolsey','Jason',
    ].map((a, i) => ({n: `SK-${i+1}`, name: a, artist: 'Sketch Card Artist'}))
  },
];
export const PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'mini-diamond', name: 'Mini-Diamond Refractor', print_run: null, color: '#b0e0ff' },
  { id: 'magenta-lava', name: 'Magenta Lava Refractor', print_run: 250, color: '#ff40a0' },
  { id: 'green-shimmer', name: 'Green Shimmer Refractor', print_run: 199, color: '#00e87a' },
  { id: 'blue-ray-wave', name: 'Blue Ray Wave Refractor', print_run: 175, color: '#2979ff' },
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'purple-speckle', name: 'Purple Speckle Refractor', print_run: 125, color: '#b060ff' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'logofractor-77', name: 'Star Wars Logofractor', print_run: 77, color: '#c9a227' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'red-logofractor', name: 'Star Wars Red Logofractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const AUTO_PARALLELS = [
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red-logofractor', name: 'Star Wars Red Logofractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const INSERT_PARALLELS = [
  { id: 'green-shimmer', name: 'Green Shimmer Refractor', print_run: 199, color: '#00e87a' },
  { id: 'blue-ray-wave', name: 'Blue Ray Wave Refractor', print_run: 175, color: '#2979ff' },
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red-logofractor', name: 'Star Wars Red Logofractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
